import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

import SummerPackageImage from '../assets/images/clock.png';
import AutumnPackageImage from '../assets/images/package_home.png';
import WinterPackageImage from '../assets/images/nabwi.png';
import RamadanPackageImage from '../assets/images/ramadan.png';

const packagesData = [

  {
    name: "Höst-Paket",
    duration: "Preliminärt 23 Oktober - 30 Oktober 2026",
    price: "17 495",
    hotell: "",
    image: RamadanPackageImage,
    link: "/umrah-package",
    status: "active",
  },
  {
    name: "Vinter-Paket",
    duration: "Preliminärt 20 December - 31 December 2026",
    price: "19 995",
    /* hotell: "Clock-Tower ⭐⭐⭐⭐⭐", */
    image: WinterPackageImage,
    link: "/umrah-package",
    status: "active",
  },

  {
    name: "Ramadan - Paket 2027",
    note: "10 Första Dagarna",
    duration: "Preliminärt 11 Februari - 20 Februari 2027",
    price: "21 995",
    hotell: "",
    image: SummerPackageImage,
    link: "/umrah-package",
    status: "active",
  },

  {
    name: "Ramadan - Paket Två 2027",
    note: "10 Sista Dagarna",
    duration: "Preliminärt 27 Februari - 9 Mars 2027",
    price: "23 995",
   /*  hotell: "Hotell ⭐⭐⭐⭐⭐", */
    image: AutumnPackageImage,
    link: "/umrah-package",
    status: "active",
  },


];

const Home = () => {
  useEffect(() => {
    document.title = "Umrah Bröderna - Startsida";

    const metaDescription = document.createElement('meta');
    metaDescription.name = "description";
    metaDescription.content =
      "Discover our exclusive Umrah packages tailored for your spiritual journey to Mecca and Medina.";
    document.head.appendChild(metaDescription);

    return () => {
      document.head.removeChild(metaDescription);
    };
  }, []);

  return (
    <div className="home-container">
      <section className="banner"></section>

      <section className="packages">
        <div className="package-navigation">
          <div className="badge">Boka din resa för 2026</div>
          <h2>
            Planera in din <span className="highlight">Spirituella Resa</span> med oss!
          </h2>
          <p>Passa på innan platserna fylls!</p>

          <div className="package-list">
            {packagesData.map((pkg, index) => (
              <div
                key={index}
                className={`package-item ${pkg.status === "inactive" ? "inactive" : ""}`}
              >
                <div className="package-image-wrapper">
                  <img src={pkg.image} alt={pkg.name} className="package-image" />
                  {pkg.status === "inactive" && (
                    <div className="unavailable-banner">Ej Tillgänglig</div>
                  )}
                </div>

                <div className="package-overlay">
                  <h3>{pkg.name}</h3>
                  <strong>{pkg.duration}</strong>

                    {/* gör så att när man skriver på "note "sfdsd" men lämnar den tomt, eller mellanslag då håller 
                    mellanrummet kvar så som det står exempelvis på 10 sista dagarna */}
                  {pkg.note && (
                    <div className={`package-note ${pkg.note?.trim() ? "" : "placeholder"}`}>
                  {pkg.note?.trim() ? `(${pkg.note})` : "\u00A0"}   
                    </div>
                  )}      

                  <div className="package-price">
                    {pkg.price ? (
                      <>Pris från <strong>{pkg.price} kr</strong></>
                    ) : (
                      <strong>Pris Kommer snart</strong>
                    )}
                  </div>

                  <div className="hotel-wrapper">
                    {pkg.hotell && <div className="package-hotel">{pkg.hotell}</div>}
                  </div>

                  {pkg.status === "inactive" ? (
                    <div className="package-buttons disabled">
                      <button disabled>Läs Mer</button>
                      <button className="boka-btn" disabled>Boka Nu</button>
                    </div>
                  ) : (
                    <>
                      {/* Rad 1 – exakt som innan */}
                      <div className="package-buttons">
                        <Link to={pkg.link}>
                          <button>Läs Mer</button>
                        </Link>

                        <Link to="/Boka">
                          <button className="boka-btn">Boka Nu</button>
                        </Link>
                      </div>

                      {/* Rad 2 – NY: centrerad Intresseanmälan */}
                      <div className="interest-row">
                        <Link to="/intresseanmalan">
                          <button className="boka-btn">Intresseanmälan</button>
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </div>
  );
};

export default Home;
